import '@wangeditor/editor/dist/css/style.css'
import React, { useState, useEffect } from 'react'
import { Editor, Toolbar } from '@wangeditor/editor-for-react'

function MyEditor(props) {
    const [editor, setEditor] = useState(null)
    
    const toolbarConfig = {}
    
    const editorConfig = {
        placeholder: '请输入内容...',
        MENU_CONF: {}
    }

    // 销毁 editor
    useEffect(() => {
        return () => {
            if (editor == null) return
            editor.destroy()
            setEditor(null)
        }
    }, [editor])

    // 图片上传配置
    editorConfig.MENU_CONF['uploadImage'] = {
        server: '/api/ReactApi/zd_single_upload_image',
        fieldName: 'image_file',
        maxFileSize: 1000 * 1024 * 1024, // 1000MB
        customInsert(res, insertFn) {
            insertFn(`/api/assets/images/application/${res.Result}`)
        },
    }

    // 视频上传配置
    editorConfig.MENU_CONF['uploadVideo'] = {
        server: '/api/ReactApi/zd_single_upload_image', // 建议使用专门视频上传接口
        fieldName: 'image_file',
        maxFileSize: 100 * 1024 * 1024, // 10MB限制
        allowedFileTypes: ['video/*'], // 限制文件类型
        customInsert(res, insertFn) {
            // 视频和图片路径可能不同，根据实际API调整
            insertFn(`/api/assets/images/application/${res.Result}`, '', {
                poster: res.PosterUrl || '' // 可添加视频封面
            })
        },
        onFailed(file, err) {
            if (err && err.message && err.message.includes('exceeds maximum allowed size')) {
                alert('视频文件大小不能超过10MB，请压缩后重新上传')
            } else {
                alert('视频上传失败: ' + (err.message || '未知错误'))
            }
        }
    }

    return (
        <>
            <div style={{ border: '1px solid #ccc', zIndex: 100 }}>
                <Toolbar
                    editor={editor}
                    defaultConfig={toolbarConfig}
                    mode="default"
                    style={{ borderBottom: '1px solid #ccc' }}
                />
                <Editor
                    defaultConfig={editorConfig}                    
                    value={props.value}
                    onCreated={setEditor}
                    onChange={(e) => { props.onChange(e.getHtml()) }}
                    mode="default"
                    style={{
                        height: props.height && Number(props.height) >= 300 ? props.height : 300, // 保证最小高度
                        minHeight: 300,
                        overflowY: 'hidden',
                        width: props.width
                    }}
                />
            </div>
        </>
    )
}

export default MyEditor